module.exports = __webpack_public_path__ + "static/media/minus_final.fa7c122a.svg";